import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { Arrowdown2 } from "../../../assets";
import { Headline, Layout, SearchInput } from "../../components";
import FaqCard from "../../components/faq_card";
import { FaqController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { AppConstants } from "../../../core/constants";

class Faq extends FaqController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getCategoriesList()
  }
  render() {
    const { categoriesList, subcategories, loading } = this.state;
    return (
      <Layout title="سوالات متداول">
        <Helmet>
          <title> سوالات متداول | بیمه زندگی هامرز   </title>
        </Helmet>



        <div className="faq ">
         
            <SearchInput loadingContent={loading} buttonTitle="جستجو" placeholder="دنبال چه موضوعی میگردی ؟ " str={this.state.str} search={this.search} onClick={()=>{}} />

          <div className="faq-content">
            <div className="faq-content-title ">


              {loading ?
                <div className="faq-card content-loading"></div>
                :

                <>
                  {categoriesList?.map((item, index) => {
                    return (
                      <>

                        <FaqCard myStyle="" isFaq title={item?.name} image={`${AppConstants.base_url_img}/${item?.picture}`} onClick={() => this.getsubCategories(item)} />

                      </>
                    )
                  })}
                </>
              }
            </div>
            <div className=" scrollbar faq-content-accordion">
              <Headline contentLoading={loading} isBold title=" سوالات عمومی بیمه نامه ها " />

              {loading ?

                <>
                  <div className="w-100 faq-accordion-loading-title content-loading"></div>
                  <div className=" content-loading mt-3"></div>
                </>

                :

                <>
                  {subcategories?.map((item, index) => {
                    return (
                      <Accordion className="faq-accordion">
                        <AccordionSummary
                          expandIcon={<img alt="هامرز" src={Arrowdown2} />}
                          aria-controls="panel1a-content"
                          className="summsry"
                          id="panel1a-header"
                        >
                          <span className="faq-accordion-title">{loading ? <div></div> : item?.question}</span>
                        </AccordionSummary>
                        <AccordionDetails
                          className="summsry"
                        >
                          <p className="faq-accordion-description">
                            {item?.answer}
                          </p>
                        </AccordionDetails>
                      </Accordion>
                    )
                  })}

                </>

              }
            </div>
          </div>
        </div>

      </Layout>
    )
  }
}

export default Faq;